var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_7998)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 0C19.7313 0 0 19.7313 0 44C0 68.2688 19.7313 88 44 88C68.2688 88 88 68.2688 88 44C88 19.7313 68.2688 0 44 0Z",
    fill: "#5BC89C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2783 29.1676C66.344 30.2332 66.344 31.9863 65.2783 33.052L39.4971 58.8332C38.9643 59.366 38.2596 59.641 37.5549 59.641C36.8502 59.641 36.1455 59.366 35.6127 58.8332L22.7221 45.9426C21.6564 44.877 21.6564 43.1238 22.7221 42.0582C23.7877 40.9926 25.5408 40.9926 26.6064 42.0582L37.5549 53.0066L61.394 29.1676C62.4596 28.0848 64.2127 28.0848 65.2783 29.1676Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_7998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.5dd4ae8cbd34f530d3796ad5064243d6.svg";
export { ForwardRef as ReactComponent };